import * as React from 'react';
import { useMemo } from 'react';

import Box from '@mui/material/Box';

import {
  Button,
  ButtonGroup,
  DataGridPremium,
  GridColDef,
} from '@sbv-clients/ui-shared';
import { nameOfFactory } from '@sbv-clients/util-misc';

import { BaseMenuResponseType } from '../../services/admin';
import { ParentMenuWithSubMenuItemsType } from '../../utils/transform';
import { ActionsType } from './use-actions';

const menuKeys = nameOfFactory<ParentMenuWithSubMenuItemsType>();

interface DetailsTableProps {
  data: ParentMenuWithSubMenuItemsType;
  actions: ActionsType;
}

const DetailsTable = ({ data, actions }: DetailsTableProps) => {
  const columns = useMemo(() => {
    return [
      {
        field: menuKeys('order'),
        headerName: 'Order',
        width: 100,
        sortable: false,
      },
      {
        field: menuKeys('label'),
        headerName: 'Label',
        width: 200,
        sortable: false,
      },
      { field: menuKeys('link'), headerName: 'Link', flex: 1, sortable: false },
      {
        field: 'actions',
        headerName: '',
        width: 200,
        sortable: false,
        filterable: false,
        align: 'right',
        renderCell: (params) => {
          const id = params?.row?.id as string;
          return (
            <Box>
              <ButtonGroup>
                <Button
                  variant="contained"
                  color="primary"
                  onClick={() => actions.onEditMenuItem(params.row)}
                >
                  Edit
                </Button>
                <Button
                  variant="contained"
                  color="error"
                  onClick={() => actions.onDeleteMenuItem(id)}
                >
                  Delete
                </Button>
              </ButtonGroup>
            </Box>
          );
        },
      },
    ] as GridColDef<BaseMenuResponseType>[];
  }, [actions]);

  return (
    <DataGridPremium
      rows={data.children}
      columns={columns}
      disableColumnMenu
      hideFooter
    />
  );
};

export default DetailsTable;
